module.exports = __webpack_public_path__ + "static/media/gomen.041a3e31.gif";